import { render, staticRenderFns } from "./FlavorText.vue?vue&type=template&id=63c4c71c&"
import script from "./FlavorText.vue?vue&type=script&lang=js&"
export * from "./FlavorText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports